import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EExternalSource } from './external-sources';
import { EModel } from './model';
export const fieldsProcedure = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  cpt: {
    type: 'Text'
  },
  date: {
    type: 'Date'
  },
  externalId: {
    type: 'Option',
    values: EExternalSource
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  }
});